import React from 'react';
import './FunctionnalitySection.css';
import { FaRunning, FaUserTie, FaBalanceScale, FaBuilding, FaBullhorn, FaUsers } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import imageLogo from './carrerup_profile_NoBg.png'

const FunctionnalitySection = () => {
  const { t } = useTranslation();
  const audiences = [
    { icon: FaRunning, code: '01', key: 'athlete' },
    { icon: FaBuilding, code: '02', key: 'club' },
    { icon: FaBalanceScale, code: '03', key: 'agent' },
    { icon: FaBullhorn, code: '04', key: 'media' },
    { icon: FaUserTie, code: '05', key: 'staff' },
    { icon: FaUsers, code: '06', key: 'fan' }
  ];

  return (
    <section className="wb-command-section" id="second-div">
      <div className="wb-command-grid" aria-hidden="true" />
      <div className="wb-command-orbit wb-command-orbit-one" aria-hidden="true" />
      <div className="wb-command-orbit wb-command-orbit-two" aria-hidden="true" />

      <div className="wb-command-shell">
        <aside className="wb-command-intro">
          <div className="wb-command-kicker"><span /> {t('websiteUi.connectedEcosystem')}</div>
          <h2>{t('platformAudience.title')}</h2>
          <p className="wb-command-lead">
            {t('website.commandLead')}
          </p>
          <div className="wb-command-status">
            <div className="wb-command-status-ring"> <img src={imageLogo} width={30}/> </div>
            <div><small>{t('websiteUi.networkStatus')}</small><strong>{t('websiteUi.ecosystemSynced')}</strong></div>
          </div>
          <div className="wb-command-line"><span /> <b>06</b> {t('website.ecosystems')}</div>
        </aside>

        <div className="wb-command-modules">
          {audiences.map(({ icon: Icon, code, key }) => (
            <article className="wb-command-card" key={key} style={{ '--delay': `${Number(code) * 90}ms` }}>
              <div className="wb-command-card-top">
                <span className="wb-command-code">{code}</span>
                <span className="wb-command-scan"><i /><i /><i /></span>
              </div>
              <div className="wb-command-icon"><Icon /></div>
              <h3>{t(`platformAudience.${key}Title`)}</h3>
              <p>{t(`platformAudience.${key}Text`)}</p>
              <div className="wb-command-card-footer"><span>{t('websiteUi.explore')}</span><span aria-hidden="true">→</span></div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FunctionnalitySection;
